import { useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Building2, Check, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const d10 = (v) => (v ? `${String(v).slice(8, 10)}.${String(v).slice(5, 7)}.${String(v).slice(0, 4)}` : "—");
const BELEGE = ["Maßnahmevertrag", "Datenschutz", "Erstgespräch", "Praktikumsvertrag", "Laufzettel", "Anwesenheit", "Prüfung", "Zertifikat"];

export const EinrichtungBelegstatus = () => {
  const [q, setQ] = useState("Homecare");
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const suchen = async () => {
    setBusy(true);
    try { setD((await axios.get(`${API}/admin/einrichtung-belegstatus`, { params: { q } })).data); } finally { setBusy(false); }
  };
  return (
    <Card className="card-custom mb-6" data-testid="einrichtung-belegstatus-card">
      <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><Building2 size={18} /> BG-Teilnehmende pro Einrichtung · Belegstatus</CardTitle></CardHeader>
      <CardContent className="pt-0 text-sm">
        <div className="flex gap-2 mb-3">
          <Input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && suchen()} placeholder="Einrichtung, z. B. Homecare" data-testid="einrichtung-belegstatus-input" />
          <Button onClick={suchen} disabled={busy || !q.trim()} data-testid="einrichtung-belegstatus-suchen">Suchen</Button>
          {d?.teilnehmer?.length > 0 && <Button variant="outline" onClick={() => window.print()} data-testid="einrichtung-belegstatus-drucken">Drucken</Button>}
        </div>
        {d && <p className="mb-2 text-stone-600" data-testid="einrichtung-belegstatus-anzahl">{d.anzahl} BG-Teilnehmende gefunden für „{d.suche}“</p>}
        {d?.teilnehmer?.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-xs border" data-testid="einrichtung-belegstatus-tabelle">
              <thead className="bg-stone-50"><tr>
                <th className="p-1 text-left">Name</th><th className="p-1 text-left">BG</th><th className="p-1 text-left">Zeitraum</th>
                {BELEGE.map((b) => <th key={b} className="p-1">{b}</th>)}
              </tr></thead>
              <tbody>{d.teilnehmer.map((t) => (
                <tr key={t.teilnehmer_id} className="border-t" data-testid={`einrichtung-belegstatus-row-${t.teilnehmer_id}`}>
                  <td className="p-1 font-medium">{t.name}</td><td className="p-1">{t.bg_nummer || "—"}</td>
                  <td className="p-1 whitespace-nowrap">{d10(t.start)} – {d10(t.ende)}</td>
                  {BELEGE.map((b) => <td key={b} className="p-1 text-center">{t.belege[b] ? <Check size={14} className="inline text-emerald-600" /> : <X size={14} className="inline text-red-600" />}</td>)}
                </tr>))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
